import { render } from "./FarmStatusCard.vue?vue&type=template&id=478c8ca7&scoped=true&bindings={}"
import script from "./FarmStatusCard.vue?vue&type=script&lang=ts"
export * from "./FarmStatusCard.vue?vue&type=script&lang=ts"

import "./FarmStatusCard.vue?vue&type=style&index=0&id=478c8ca7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-478c8ca7"

export default script